/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './authManageLabelerService.defs.js'
export * as $defs from './authManageLabelerService.defs.js'
